import { render, staticRenderFns } from "./Gstr3bTab.vue?vue&type=template&id=4c720347&"
import script from "./Gstr3bTab.vue?vue&type=script&lang=js&"
export * from "./Gstr3bTab.vue?vue&type=script&lang=js&"
import style0 from "./Gstr3bTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports